import { render } from "./EditReportList.vue?vue&type=template&id=2f2daa30"
import script from "./EditReportList.vue?vue&type=script&lang=js"
export * from "./EditReportList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__